import React from 'react';
import moment from 'moment';

export default ({ date, deleteItem, disabled }) => {
    return (
        <div className="multiple-date">
            <p>{moment(date.date).format('YYYY-MM-DD')}</p>
            {!disabled ? (
                <button
                    className="remove-dates"
                    type="button"
                    onClick={deleteItem}
                >
                    <svg className="icon icon-close">
                        <use
                            xmlnsXlink="http://www.w3.org/1999/xlink"
                            xlinkHref="#icon-close"
                        />
                    </svg>
                </button>
            ) : null}
        </div>
    );
};



// WEBPACK FOOTER //
// ./src/components/event/event-details/form-information/on-site-date.js